import {Component, inject} from '@angular/core';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import { ActionCardPreviewComponent } from 'shared-lib';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import {CampaignsListComponentComponent} from '../campaigns-list-component.component';
import {CampaignsWithLoyaltyStore} from '../../../../store/paged-campaigns.store';

@Component({
    selector: 'app-campaign-with-loyalty-list',
    templateUrl: '../campaigns-list-component.component.html',
    styleUrl: '../campaigns-list-component.component.scss',
    imports: [ActionCardPreviewComponent, MatProgressSpinner]
})
export class CampaignsWithLoyaltyListComponent extends CampaignsListComponentComponent {
  private activeCampaignsStore = inject(CampaignsWithLoyaltyStore);

  constructor(bottomSheet: MatBottomSheet) {
    super(bottomSheet)
  }

  protected override getStore = () => this.activeCampaignsStore;
}

